var exports = {
  "nd": "x127c5a35--070cc6--base_info",
  "rW": "x127c5a35--070cc6--price_info",
  "D7": "x127c5a35--070cc6--shields_wrapper",
};

module.exports = exports;
